import ValidationUtils from './ValidationUtils';

export function getUrlHostname(url: string = '') {
  // eslint-disable-next-line no-useless-escape
  const isUrlRegex = /^(https?:\/\/)?([\w\-]+\.)+[\w\-]+(\/[\w\- .\/?%&=]*)?$/;

  if (!isUrlRegex.test(url)) return url;

  const hostname = new URL(url).hostname;
  const hostnameWithoutWWW = hostname.replace(/^www\./, '');

  return hostnameWithoutWWW;
}
